import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
} from "@mui/material";
import React, { useEffect } from "react";
const dataMock = {
  Data: {
    detail:
      `<li><strong>หุ้น Cash</strong></br>บัญชีซื้อขายหุ้นที่จะต้องวางหลักประกันก่อนการซื้อขายหุ้นประมาณ 20% ของมูลค่าวงเงินซื้อขายที่ต้องการ</li>
      <li><strong>หุ้น Cash Balance</strong></br>บัญชีซื้อขายหุ้นที่จะต้องฝากเงินจากบัญชีธนาคารเข้าบัญชีซื้อขายหุ้น 100% ของมูลค่าที่ต้องการจะซื้อขายหุ้น โดยวงเงินในการซื้อขายจะเท่ากับเงินสดที่ฝากเข้ามาเป็นหลักประกัน</li><li><strong>หุ้น Credit Balance</strong></br>บัญชีซื้อขายหุ้นที่เหมาะกับนักลงทุนที่ต้องการเพิ่มอำนาจซื้อโดยการกู้เงินจากบริษัทส่วนหนึ่ง</li>
      <li><strong>หุ้น DAOL SEC Smart Algo</strong></br>ซื้อขายหุ้นอัตโนมัติด้วยนวัตกรรม Algorithmic จากการเลือกกลยุทธ์การลงทุนที่สอดคล้องกับสภาวะการลงทุนที่หลากหลาย</li><li><strong>หุ้น DCA</strong></br>บัญชีออมหุ้นรายเดือนและรายสัปดาห์ผ่านระบบซื้อขาย Settrade Streaming หรือ DAOL SEC Trade เริ่มต้นเพียง 1,000 บาท</li>
      <li><strong>อนุพันธ์ DAOL SEC Smart Algo</strong></br>ซื้อขายอนุพันธ์อัตโนมัติด้วยนวัตกรรม Algorithmic Trading System</li>
      <li><strong>กองทุนรวม Omnibus</strong></br>บัญชีซื้อขายกองทุนรวมทั่วไปกับ บลจ. ชั้นนำ บนระบบ Streaming For Fund</li>
      <li><strong>กองทุนรวม Segregate</strong></br>บัญชีซื้อขายกองทุนรวม RMF หรือ SSF กับ บลจ. ชั้นนำ</li>
      <li><strong>กองทุนรวม DAOL SEC Wealth Advice</strong></br>บริการวางแผนลงทุนในกองทุนรวมอัตโนมัติ เพื่อบรรลุเป้าหมายทางการเงิน</li>
      <li><strong>ซื้อขายหุ้น กองทุนรวม ETF และ structured Note ต่างประเทศ ประเภท OTC</strong></br>บริการซื้อขายหุ้น กองทุนรวม ETF และ structured Note ต่างประเทศ ประเภท OTC ผ่านผู้แนะนำการลงทุน</li>
      <li><strong>DAOL SEC Smart Foreign</strong></br>ซื้อขายหุ้นต่างประเทศและ ETF ผ่านแพลตฟอร์มออนไลน์ที่ปลอดภัย บริการซื้อขายหลักทรัพย์และ ETFs ต่างประเทศ ในประเทศสหรัฐอเมริกาและฮ่องกง ผ่านแพลตฟอร์มซื้อขายออนไลน์</li>
      <li><strong>ตราสารหนี้ Debt Capital Markets (DCM)</strong></br>บัญชีซื้อขายตราสารหนี้</li><li><strong>ตราสารหนี้ Secondary Market Services</strong></br>บัญชีซื้อขายตราสารหนี้ผ่านตลาดรอง</li>`,
  },
};
export default function ProductsType(props) {
  const { open, isModel, btn } = props;
  const massage = dataMock.Data?.detail;
  const handleClose = (type) => {
    isModel(!open);
  };
  useEffect(() => {});
  return (
    <Dialog open={open}>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          className="font-title text-left font-22"
          dangerouslySetInnerHTML={{
            __html: massage,
          }}
        />
      </DialogContent>
      <DialogActions
        style={{
          paddingTop: "35px",
        }}
      >
        <Button onClick={() => handleClose("")} className="btn-next font-20">
          {btn}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
